import React from 'react'
import PropTypes from 'prop-types'

const DynamitePress = ({ item }) => {
  return (
    <article className="dynamite-press">
      <a className="dynamite-press-link" href={item.fields.article_link} target="_blank">
        {item.featured_image && (
          <img
            className="dynamite-press-featured-image"
            src={item.featured_image.medium[0]}
            alt=""
          />
        )}
        <header className="dynamite-press-copy">
          <div className="press-item-meta type-body mod-ui">
            <span className="press-item-tag mod-date">{item.post_date}</span>
            <span className="press-item-tag mod-type">{item.fields.article_type}</span>
          </div>
          <h1 className="press-item-tag mod-title type-body mod-ui">{item.post_title}</h1>
        </header>
      </a>
    </article>
  )
}

DynamitePress.propTypes = {
  item: PropTypes.object.isRequired
}

export default DynamitePress
